const rtpMap = {
    'tikiz_n_juice_96': {
        bonusBuy: 96.57,
    },
    'tikiz_n_juice_94': {
        bonusBuy: 94.20,
    },
    'tikiz_n_juice_89': {
        bonusBuy: 89.49,
    },
}

const getBuyBonusRTPByGameCode = gameCode => rtpMap[gameCode];

export {getBuyBonusRTPByGameCode};
